import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a226574c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a226574c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a226574c')) {
      api.createRecord('a226574c', component.options)
    } else {
      api.reload('a226574c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a226574c&scoped=true", function () {
      api.rerender('a226574c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onePass/onePassConfig/index.vue"
export default component.exports